import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useRole } from "@/hooks/useRole";

/**
 * useRole ベースの表示ガード（UXガード専用。認可の正はバックエンド）。
 *
 * 状態機械:
 * - isLoading → null（描画保留。auth-me 取得中は何も出さない）
 * - 不許可 → fallback="redirect" なら <Navigate to="/" replace />、"none" なら null
 * - 許可 → children
 */
export default function RequireRole({
  allow,
  children,
  fallback = "redirect",
}: {
  allow: (r: ReturnType<typeof useRole>) => boolean;
  children: ReactNode;
  fallback?: "redirect" | "none";
}) {
  const role = useRole();

  if (role.isLoading) return null;

  if (!allow(role)) {
    return fallback === "redirect" ? <Navigate to="/" replace /> : null;
  }

  return <>{children}</>;
}
